import { render, staticRenderFns } from "./GalleryHorizontal.vue?vue&type=template&id=694bdd20&"
import script from "./GalleryHorizontal.vue?vue&type=script&lang=js&"
export * from "./GalleryHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694bdd20')) {
      api.createRecord('694bdd20', component.options)
    } else {
      api.reload('694bdd20', component.options)
    }
    module.hot.accept("./GalleryHorizontal.vue?vue&type=template&id=694bdd20&", function () {
      api.rerender('694bdd20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/product/gallery/GalleryHorizontal.vue"
export default component.exports